import React, {Component} from "react";
import {rfidActions} from "../../../../actions/rfid.actions";
import {connect} from "react-redux";
import {withNamespaces} from "react-i18next";
import {exhibitionScenarioActions} from "../../../../actions/exhibition-scenario.actions";

class WidgetVisitAddVisitForm extends Component {

    state = {
        form: {
            pcName: null,
            rfidCode: null,
            pathName: null,
            language: 'pl-PL',
            groupCount: 4
        },
        languages: ['pl-PL', 'en-GB', ['ru-RU']],
        groupCount: [ 4,5,6 ]
    }

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(rfidActions.getUnusedTags());
        dispatch(exhibitionScenarioActions.getDropdownListExhibitionScenario());
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if((prevProps.unusedList !== this.props.unusedList) && this.props.unusedList) {
            this.setState({
                ...this.state,
                form: {
                    ...this.state.form,
                    rfidCode: this.props.unusedList.length > 0 ?
                        this.props.unusedList[0].tag :
                        null,
                }
            });
        }

        if((prevProps.exhibitionScenarioDropdown !== this.props.exhibitionScenarioDropdown) && this.props.exhibitionScenarioDropdown) {
            this.setState({
                ...this.state,
                form: {
                    ...this.state.form,
                    pathName: this.props.exhibitionScenarioDropdown.length > 0 ?
                        this.props.exhibitionScenarioDropdown[0].scenarioKey:
                        null
                }
            })
        }
    }

    handleOnChangeSelect = (e) => {
        this.setState({
            ...this.state,
            form: {
                ...this.state.form,
                [e.target.name]: e.target.value
            }
        });
    };


    handleSubmit = (e) => {
        e.preventDefault();
        const {submit} = this.props;
        submit(this.state.form);
    };

    render() {
        const { t, unusedList, exhibitionScenarioDropdown } = this.props;
        const { languages, groupCount } = this.state;
        return (
            <React.Fragment>
                { unusedList?.length > 0 ? (
                    <form onSubmit={this.handleSubmit} >
                        <div className="form-group">
                            <label className="col-form-label">{ t('select-rfid-code') }</label>
                            <select className="form-control" name="rfidCode" onChange={(e) => this.handleOnChangeSelect(e)}>
                                { unusedList?.map((code, idx) => {
                                    return (
                                        <option key={idx} value={code.tag}> { code.label } - {code.tag} </option>
                                    )
                                }) }
                            </select>
                        </div>

                        <div className="form-group">
                            <label className="col-form-label">{ t('select-exhibition-scenario') }</label>
                            <select className="form-control" name="pathName" onChange={(e) => this.handleOnChangeSelect(e)}>
                                { exhibitionScenarioDropdown?.map((scenario, idx) => {
                                    return (
                                        <option key={idx} value={scenario.scenarioKey || ''}> {scenario.label} </option>
                                    )
                                }) }
                            </select>
                        </div>

                        <div className="form-group">
                            <label className="col-form-label">{ t('select-language') }</label>
                            <select className="form-control" name="language" onChange={(e) => this.handleOnChangeSelect(e)}>
                                { languages?.map((lang, idx) => {
                                    return (
                                        <option key={idx} value={lang}> {lang} </option>
                                    )
                                }) }
                            </select>
                        </div>

                        <div className="form-group">
                            <label className="col-form-label">{ t('select-count-group') }</label>
                            <select className="form-control" name="groupCount" onChange={(e) => this.handleOnChangeSelect(e)}>
                                { groupCount?.map((lang, idx) => {
                                    return (
                                        <option key={idx} value={lang}> {lang} </option>
                                    )
                                }) }
                            </select>
                        </div>


                        <div className="form-group float-right">
                            <button type="submit" className={"btn btn-success" }>
                                <i className="fas fa-plus"> </i> {t('add-visit')}
                            </button>
                        </div>
                    </form>
                ) : (<p>{t('all-carts-is-used')}</p>) }

            </React.Fragment>
        );
    }
}
const mapStateToProps = (state) => {
    const { unusedList } = state.rfidReducer;
    const { exhibitionScenarioDropdown } = state.exhibitionScenarioReducer;
    return {
        unusedList, exhibitionScenarioDropdown
    }
};
export default withNamespaces()(connect(mapStateToProps)(WidgetVisitAddVisitForm));